@switch (resource.status()) {
    @case ('loading') {
        @if (loadingTemplate) {
            <ng-container *ngTemplateOutlet="loadingTemplate; context: { $implicit: resource }"></ng-container>
        } @else {
            <div class="loading-state">
                <p i18n>Loading...</p>
            </div>
        }
    }
    @case ('error') {
        @if (errorTemplate) {
            <ng-container *ngTemplateOutlet="errorTemplate; context: { $implicit: resource.error() }"></ng-container>
        } @else {
            <div class="error-state">
                <p i18n>Error loading content</p>
                <pre>{{ resource.error() }}</pre>
            </div>
        }
    }
    @case ('resolved') {
        @if (resource.hasValue()) {
            <ng-container *ngTemplateOutlet="content"></ng-container>
        } @else if (emptyTemplate) {
            <ng-container *ngTemplateOutlet="emptyTemplate"></ng-container>
        } @else {
            <div class="empty-state">
                <p i18n>No data available</p>
            </div>
        }
    }
}

<ng-template #content>
    <ng-content></ng-content>
</ng-template>
